export default function isNullOrUndefined(value: unknown): value is undefined | null {
  return (typeof (value) === 'undefined' || value === null);
}
